/**
 * http配置
 */
import iView from 'view-design';
import router from '../../src/router.js'
import axios from 'axios'
let l = true;

// 发送请求前
axios.interceptors.request.use(
	config => {
		// 判断不是登录接口
		if (config.url.indexOf('login') == -1) {

			if (!localStorage.AccessToken) {


				window.App.$router.push('/login')
			} else {
				// let _token = localStorage.bearer
				// // config.headers['ip'] = localStorage.userIp
				// _token && (config.headers['Authorization'] = _token);
				localStorage.AccessToken && (config.headers['Authorization'] = "Bearer " + encodeURIComponent(localStorage.AccessToken))
				//sessionStorage.setItem("apiString", config.url)
			}

		} else {

		}

		config.timeout = 1800000
		return config;
	},
	err => {
		return Promise.reject(err);
	}
)



// 响应
axios.interceptors.response.use(
	response => {
		// 定时刷新access-token
		console.log("axios守卫：收到response")
		return response
	},
	error => {
		if (error.response) {
			if(error.response.status==401){
				//window.App.$Message.warning('token失效,请重新登陆');
				window.App.$router.push('/login')
				return Promise.reject(error)
			}else{	
				window.App.$Message.warning("接口："+error.response.request.responseURL.split('/')[4]+'/'+error.response.request.responseURL.split('/')[5]+" 请求错误");
			}
		} else {
				window.App.$Message.warning("接口："+error);
				return Promise.reject(error)
		}
	}
)
export default axios
